import "./App.css";
import createRoutes from "./routes/routes";

function App() {
  const routes = createRoutes();

  return routes;
}

export default App;
